import {
    GET_ALL_EVENT_LOADING,
    GET_ALL_EVENT_SUCCESS,
    GET_ALL_EVENT_FAILURE
} from '../../actions/types';

const INITIAL_STATE = {
    events: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        },
    },
};

const allEventReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ALL_EVENT_LOADING:
            return {
                ...state,
                events: {
                    ...state.events,
                    get: {
                        ...state.events.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.events.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_ALL_EVENT_SUCCESS:
            return {
                ...state,
                events: {
                    ...state.events,
                    get: {
                        ...state.events.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.events.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_ALL_EVENT_FAILURE:
            return {
                ...state,
                events: {
                    ...state.events,
                    get: {
                        ...state.events.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.events.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.events.message,
                        },
                    },
                },
            };
    }
    return state;
}

export default allEventReducers;